module.exports = __webpack_public_path__ + "img/home.37bb6437.svg";